export const initialLeads = [
  {
    id: "RPM-1001",
    name: "Somchai Techaphan",
    company: "Nexus Innovations Co., Ltd.",
    email: "somchai@nexusinnovations.co.th",
    phone: "081-456-7890",
    lineId: "@somchai_nexus",
    channel: "line",
    status: "qualified",
    score: 92,
    businessType: "Technology",
    propertyType: "Office",
    space: "120 sqm",
    timeline: "< 3 months",
    budget: "฿65,000 - ฿85,000 / mo",
    assignedTo: "TBS Sales Team",
    createdAt: "2026-08-25T08:30:00Z",
    lastActivity: "2026-08-25T09:15:00Z",
    intent: "High",
    urgency: "Immediate",
    notes: [
      { id: 1, author: "TBS Sales Team", text: "Client prefers high floor with city view.", date: "2026-08-25T09:15:00Z" }
    ],
    conversation: [
      { sender: "user", text: "Hello, interested in leasing office space.", time: "14:30" },
      { sender: "bot", text: "Welcome to TBS CRM! What is your required space size in sqm?", time: "14:30" },
      { sender: "user", text: "Around 100 - 120 sqm.", time: "14:31" },
      { sender: "bot", text: "Got it! When are you planning to move in?", time: "14:31" },
      { sender: "user", text: "Within 3 months.", time: "14:31" }
    ]
  },
  {
    id: "RPM-1002",
    name: "Natarika Sooksamran",
    company: "Artisan Coffee Roasters",
    email: "natarika@artisancoffee.com",
    phone: "089-123-4567",
    lineId: "natarika_c",
    channel: "facebook",
    status: "site_visit",
    score: 88,
    businessType: "Restaurant",
    propertyType: "Retail Shop",
    space: "80 sqm",
    timeline: "< 1 month",
    budget: "฿50,000 - ฿70,000 / mo",
    assignedTo: "TBS Specialist",
    createdAt: "2026-08-24T10:15:00Z",
    lastActivity: "2026-08-25T08:30:00Z",
    intent: "High",
    urgency: "High",
    notes: [
      { id: 1, author: "TBS Specialist", text: "Site visit scheduled for tomorrow 11:00 AM.", date: "2026-08-24T16:00:00Z" }
    ],
    conversation: []
  },
  {
    id: "RPM-1003",
    name: "Chaiwat Vora-indr",
    company: "Siam Marine Logistics Ltd.",
    email: "chaiwat@siammarine.co.th",
    phone: "086-789-0123",
    lineId: "@chaiwat_sml",
    channel: "google",
    status: "proposal",
    score: 95,
    businessType: "Logistics",
    propertyType: "Warehouse / Office",
    space: "450 sqm",
    timeline: "< 2 months",
    budget: "฿180,000 / mo",
    assignedTo: "TBS Sales Team",
    createdAt: "2026-08-23T09:00:00Z",
    lastActivity: "2026-08-25T07:45:00Z",
    intent: "Very High",
    urgency: "Immediate",
    notes: [
      { id: 1, author: "TBS Sales Team", text: "Sent official proposal v2 with custom clearance terms.", date: "2026-08-24T14:00:00Z" }
    ],
    conversation: []
  },
  {
    id: "RPM-1004",
    name: "Piyabutr Prasert",
    company: "Apex Legal Advisory",
    email: "piyabutr@apexlegal.co.th",
    phone: "082-345-6789",
    lineId: "piya_apex",
    channel: "website",
    status: "leased",
    score: 98,
    businessType: "Law",
    propertyType: "Executive Suite",
    space: "200 sqm",
    timeline: "Immediate",
    budget: "฿120,000 / mo",
    assignedTo: "TBS Account Executive",
    createdAt: "2026-08-20T11:20:00Z",
    lastActivity: "2026-08-24T17:00:00Z",
    intent: "Converted",
    urgency: "Done",
    notes: [
      { id: 1, author: "TBS Account Executive", text: "Lease contract signed for 3 years! Security deposit paid.", date: "2026-08-24T17:00:00Z" }
    ],
    conversation: []
  },
  {
    id: "RPM-1005",
    name: "Araya Rungruang",
    company: "Glow Wellness Spa & Clinic",
    email: "araya@glowwellness.com",
    phone: "085-678-9012",
    lineId: "@glow_araya",
    channel: "tiktok",
    status: "contacted",
    score: 74,
    businessType: "Wellness",
    propertyType: "Retail Shop",
    space: "150 sqm",
    timeline: "3-6 months",
    budget: "฿90,000 / mo",
    assignedTo: "TBS Specialist",
    createdAt: "2026-08-24T08:45:00Z",
    lastActivity: "2026-08-25T06:20:00Z",
    intent: "Medium",
    urgency: "Flexible",
    notes: [],
    conversation: []
  },
  {
    id: "RPM-1006",
    name: "Worawat Thanaporn",
    company: "Vanguard Capital Partners",
    email: "worawat@vanguardcap.com",
    phone: "084-567-8901",
    lineId: "worawat_vc",
    channel: "email",
    status: "new",
    score: 65,
    businessType: "Finance",
    propertyType: "Office",
    space: "300 sqm",
    timeline: "3-6 months",
    budget: "฿200,000 / mo",
    assignedTo: "TBS Sales Team",
    createdAt: "2026-08-25T09:40:00Z",
    lastActivity: "2026-08-25T09:40:00Z",
    intent: "Medium",
    urgency: "Low",
    notes: [],
    conversation: []
  }
];
